import { FC } from "react";
import { RankLoyalty } from "types/Loyalty";
import LoyaltyTagStatusRank from "components/atoms/LoyaltyTagStatusRank";
import LoyaltyListRewards from "components/molecules/LoyaltyListRewards";
import { StatusRank } from "components/atoms/LoyaltyRankStatus/types";
import { RewardItemT } from "components/molecules/LoyaltyListRewards/types";
import { LoyaltyTagStatusVariantT } from "components/atoms/LoyaltyTagStatusRank/types";
import "./styles.sass";
import useTranslate from "../../../hooks/useTranslate";

type LoyaltyProgressRankDetailProps = {
  rank?: RankLoyalty;
  statusProgress: StatusRank;
  rewardsRankStatus: LoyaltyTagStatusVariantT;
  rewardsRank: RewardItemT[];
  rewardsLevels?: Array<{
    title: string;
    status: StatusRank;
    rewards: RewardItemT[];
  }>;
  image?: string;
};

const LoyaltyProgressRankDetail: FC<LoyaltyProgressRankDetailProps> = (
  props,
) => {
  const {
    rank,
    image,
    rewardsRank,
    rewardsLevels,
    statusProgress,
    rewardsRankStatus,
  } = props;
  const t = useTranslate();

  return (
    <div className="LoyaltyProgressRankDetail">
      <div className="LoyaltyProgressRankDetail__top">
        <div>
          <h3 className="LoyaltyProgressRankDetail__rank">
            {t(rank?.name || null)}
          </h3>
          <LoyaltyTagStatusRank status={rewardsRankStatus} />
        </div>
        <img
          src={image}
          alt="image-rank"
          className="LoyaltyProgressRankDetail__image"
        />
      </div>
      <div className="LoyaltyProgressRankDetail__rewards">
        {rewardsRank && rewardsRank.length > 0 && (
          <>
            <LoyaltyListRewards
              title=""
              rewards={rewardsRank}
              status={statusProgress}
              isRank
            />
            <hr className="LoyaltyProgressRankDetail__line" />
          </>
        )}
        {rewardsLevels?.map((level) => (
          <LoyaltyListRewards
            key={level.title}
            title={level.title}
            status={level.status}
            rewards={level.rewards}
          />
        ))}
      </div>
    </div>
  );
};

export default LoyaltyProgressRankDetail;
